import type { ChatMessageResponse } from '../types/krybot';

/**
 * Merge DB `metadata` and top-level `llm_metadata` from Krybot chat APIs into one object
 * for UI (command_suggestions, artifact_payload, model_snapshot, etc.).
 *
 * For GGCC fields (`claude_project_ref`, `kryspace_company_slug_hint`), use
 * `extractKrybotTraceabilityFromMetadata` from `./krybotProspectingMetadata` on the merged object.
 */
export function mergeKrybotMessageMetadata(
  msg: ChatMessageResponse & { metadata?: Record<string, unknown> }
): Record<string, unknown> {
  const db =
    msg.metadata && typeof msg.metadata === 'object' && !Array.isArray(msg.metadata)
      ? msg.metadata
      : {};
  const lm =
    msg.llm_metadata && typeof msg.llm_metadata === 'object' && !Array.isArray(msg.llm_metadata)
      ? (msg.llm_metadata as Record<string, unknown>)
      : {};
  return { ...db, ...lm };
}
